<template>
  <home-page
    :kicker="kicker"
    :title="t.greeting(firstName)"
    :lead="lead"
    :actions="[t.actions.primary, t.actions.secondary]"
    :stats="stats"
    :setup="setup"
    :tiles-title="t.tilesTitle"
    :tiles="tiles"
    :footnote="t.footnote"
    :loading="loading"
  />
</template>

<script>
import homePages from '@/content/homePages';
import HomePage from '@/views/component/home/HomePage.vue';

const toDate = value => (value ? new Date(String(value).replace(' ', 'T')) : null);

export default {
  name: 'uwelcome',

  components: { HomePage },

  data: () => ({
    t: homePages.user,
    loading: true
  }),

  computed: {
    app() {
      return this.$store.state.UserApp;
    },
    firstName() {
      const user = this.$store.state.UserAuth.user;
      return (user && user.vorname) || '';
    },
    kicker() {
      return this.$store.state.UserAuth.defClub || this.t.kickerFallback;
    },
    runningEntry() {
      const entries = this.app.OpenShootingBookEntry;
      return Array.isArray(entries) && entries.length > 0 ? entries[0] : null;
    },
    lastEntry() {
      const last = this.app.Dashboard.SBLastEntry;
      return last && last.beginn ? last : null;
    },
    lead() {
      if (this.runningEntry) {
        const begin = toDate(this.runningEntry.beginn);
        const time = begin ? begin.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' }) : '';
        return this.t.lead.running(time, this.runningEntry.Club);
      }
      if (this.lastEntry) {
        const date = toDate(this.lastEntry.beginn).toLocaleDateString('de-DE');
        return this.t.lead.lastEntry(date, this.lastEntry.waffe);
      }
      return this.loading ? '' : this.t.lead.empty;
    },
    stats() {
      const d = this.app.Dashboard;
      const s = this.t.stats;
      const weaponCaption = [
        d.WeaponsTransferCount > 0 ? s.weapons.captionReceived(d.WeaponsTransferCount) : '',
        d.WeaponsMyTransferCount > 0 ? s.weapons.captionLent(d.WeaponsMyTransferCount) : ''
      ].filter(Boolean).join(', ');
      const myEdu = this.app.Education.myEdu || [];

      return [
        { id: 'entries', value: d.SBCount || 0, label: s.entries.label, to: '/user/shootingbook' },
        {
          id: 'open',
          value: d.SBOpenCount || 0,
          label: s.open.label,
          caption: s.open.caption,
          to: '/user/shootingbook',
          highlight: d.SBOpenCount > 0
        },
        { id: 'weapons', value: d.WeaponsCount || 0, label: s.weapons.label, caption: weaponCaption, to: '/user/weapon' },
        { id: 'education', value: myEdu.length, label: s.education.label, caption: s.education.caption, to: '/user/education' }
      ];
    },
    myClubs() {
      return (this.app.Clubs && this.app.Clubs.meineVereine) || [];
    },
    hasMainClub() {
      const data = this.app.OpenShootingBookData;
      return !!(data && data.Club && data.Club.Vereinsnummer !== '99999');
    },
    setup() {
      if (this.loading) return null;
      const done = {
        club: this.myClubs.length > 0,
        mainClub: this.hasMainClub,
        weapons: this.app.Weapons.length > 0,
        education: (this.app.Education.myEdu || []).length > 0
      };
      // Nur zeigen, solange noch ein Pflichtschritt fehlt
      const steps = this.t.setup.steps.map(step => ({ ...step, done: done[step.id] }));
      if (steps.every(step => step.done || step.optional)) return null;
      return { ...this.t.setup, steps };
    },
    tiles() {
      const can = this.$store.getters['UserAuth/userCan'];
      const menuRoutes = this.menuRoutes;
      const visible = {
        // Wie im Menü aus dem Backend (MenuController): nur mit Waffenpool-Recht in einem Verein
        weaponpool: menuRoutes.includes('/user/weaponpool'),
        workinghours: can.arbeitsstunden,
        assignments: can.arbeitseinsaetze,
        // Nur wer in einem Verein als Schießleiter eingetragen ist (pivot is_schiessleiter)
        rangeofficer: menuRoutes.includes('/user/schiessleiter/today')
      };
      return this.t.tiles.filter(tile => !(tile.id in visible) || !!visible[tile.id]);
    },
    menuRoutes() {
      const menu = this.$store.getters['UserAuth/GET_USERMENU'] || [];
      return menu.flatMap(group => (group.entry || []).map(entry => entry.route));
    }
  },

  async created() {
    const load = action => this.$store.dispatch(`UserApp/${action}`);
    await Promise.all([
      load('getDashboard'),
      load('getOpenShootingBookEntry'),
      load('getOpenShootingBookData'),
      load('getWeapons'),
      load('getClubs'),
      load('getEduData')
    ]);
    this.loading = false;
  }
};
</script>
